<script lang="ts" setup></script>

<template>
  <span class="icon">
    <svg-icon name="icon-arrow-right2" />
  </span>
</template>

<style lang="scss" scoped>
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: toRem(47);
  height: toRem(47);
  border: 1px solid $color-gray-line;
  border-radius: 50%;
  color: $color-brand-3;
  &.brand4-1 {
    color: $color-brand-4_1;
  }
}
</style>
